import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class PointageEvent extends UserEvent {
  public static NAME = 'POINTAGE_EVENT';

  constructor(
    public idCreneau: string,
    public idVacation: string,
    public idPointeau: string,
    public iteration: number,
    public parcours: boolean,
    instant: dayjs.Dayjs,
    coordinates?: Coordinates
  ) {
    super(PointageEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: PointageEvent): PointageEvent {
    return new PointageEvent(obj.idCreneau, obj.idVacation, obj.idPointeau, obj.iteration, obj.parcours, obj.instant, obj.coordinates);
  }
}
